import { Container, Loader } from "@mantine/core";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useGetEvents } from "../api/event";
import { useGetWorkspaces } from "../api/workspace";
import { AuthContext } from "../services/context";
import updateConfig, { getCurrentWorkspace } from "../services/userConfig";
import { useUpdateUser } from "../api/user";
import classes from "../components/Workspaces/WorkspaceDashboard.module.css";
import { WorkspaceList } from "../components/Workspaces/WorkspaceList";
import { EventList } from "../components/Workspaces/EventList";

export default function WorkspaceDashboard() {
  const { user, setUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const { mutate: updateUser } = useUpdateUser({
    id: user?.id,
    config: { hideNotification: true },
  });

  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [eventsPage, setEventsPage] = useState(1);
  const currentWorkspace = getCurrentWorkspace(user);

  const { data: workspacesData, isPending: isPendingWorkspaces } =
    useGetWorkspaces({ page: 1, limit: 100 });

  const { data: eventsData, isPending: isPendingEvents } = useGetEvents({
    workspace: selectedWorkspace?.id,
    page: eventsPage,
  });

  useEffect(() => {
    if (currentWorkspace && !selectedWorkspace) {
      setSelectedWorkspace(currentWorkspace);
    }
  }, [currentWorkspace, selectedWorkspace]);

  const handleSelectWorkspace = (workspace) => {
    setSelectedWorkspace(workspace);
    setEventsPage(1);
  };

  const handleSelectEvent = (event) => {
    updateConfig({
      workspace: selectedWorkspace,
      user,
      setUser,
      mutate: updateUser,
      eventId: event.id,
    });
  };

  const handleCreateEvent = () => {
    updateConfig({
      workspace: selectedWorkspace,
      user,
      setUser,
      mutate: updateUser,
    });
    navigate("/app/events/create");
  };

  const statusColor = (status) => {
    switch (status) {
      case "active":
        return "green";
      case "closed":
        return "red";
      default:
        return "gray";
    }
  };

  const currentEventId = currentWorkspace?.eventId;

  if (isPendingWorkspaces) return <Loader size="xl" />;

  const showWorkspaces =
    user?.role === "sysAdmin" || user?.workspaces?.length > 0;

  const isAdmin = user?.role === "sysAdmin";

  return (
    <Container size="xl" className={classes.hub}>
      {showWorkspaces && (
        <WorkspaceList
          workspaces={workspacesData?.data}
          selectedWorkspaceId={selectedWorkspace?.id}
          onSelectWorkspace={handleSelectWorkspace}
          isAdmin={isAdmin}
        />
      )}

      {selectedWorkspace && (
        <div
          style={{
            marginTop: showWorkspaces ? "var(--mantine-spacing-xl)" : 0,
          }}
        >
          <EventList
            events={eventsData?.data}
            pagination={eventsData?.pagination}
            onPageChange={setEventsPage}
            currentEventId={currentEventId}
            onSelectEvent={handleSelectEvent}
            onCreateEvent={handleCreateEvent}
            isAdmin={isAdmin}
            isPending={isPendingEvents}
            statusColor={statusColor}
          />
        </div>
      )}
    </Container>
  );
}
